import { Controller } from "@hotwired/stimulus"

// Fades in the hero video on the auth layout once it's ready to play
export default class extends Controller {
  static targets = ["video"]

  connect() {
    if (!this.hasVideoTarget) return

    const video = this.videoTarget

    // Ensure attributes for autoplay compatibility
    video.muted = true
    video.playsInline = true
    video.autoplay = true
    video.loop = true

    // When the browser determines it can play through, start playback
    const onCanPlayThrough = () => {
      // Start playback, then fade in when actually playing
      const playPromise = video.play()
      if (playPromise && typeof playPromise.then === "function") {
        playPromise.then(() => {
          // Wait for the 'playing' event to ensure first frame is shown
          if (video.readyState >= 2) this._fadeIn()
        }).catch(() => {
          // If autoplay fails, do nothing so the image fallback remains visible
        })
      } else {
        if (video.readyState >= 2) this._fadeIn()
      }
    }

    const onPlaying = () => this._fadeIn()

    video.addEventListener("canplaythrough", onCanPlayThrough, { once: true })
    video.addEventListener("playing", onPlaying, { once: true })

    this._cleanup = () => {
      video.removeEventListener("canplaythrough", onCanPlayThrough)
      video.removeEventListener("playing", onPlaying)
    }
  }

  disconnect() {
    if (this._cleanup) this._cleanup()
  }

  _fadeIn() {
    // Transition from opacity-0 to opacity-100
    this.videoTarget.classList.remove("opacity-0")
    this.videoTarget.classList.add("opacity-100")
  }
}


